module.exports = __webpack_public_path__ + "img/translator_en.7f84882.svg";